import { Options, Vue, setup } from "vue-class-component";
import Checkbox from "primevue/checkbox";
import { appAxios } from "@/core/utils/appAxios";
import { APIResponse, OrderDto } from "@/shared/api-contract/api-contract";
import { Model } from "vue-property-decorator";
import PdfApp from "vue3-pdf-app";
import "vue3-pdf-app/dist/icons/main.css";
import { useI18n } from "@/shared/composables/use-i18n";

@Options({
    components: {
        Checkbox,
        PdfApp,
    },
    emits: ["close"],
})
export class OrderApprovePopup extends Vue {
    @Model("_approveOrders", { required: true })
    approveOrders!: OrderDto[];
    isFinishedViewingPdf = false;
    pdf = "";
    i18n = setup(useI18n);
    pdfPage = 1;
    pdfConfig = {
        toolbar: {
            toolbarViewerLeft: true,
            toolbarViewerRight: false,
            toolbarViewerMiddle: {
                zoomOut: true,
                zoomIn: true,
                scaleSelectContainer: false, // TODO show dependin on width
            },
        },
    };

    unBindPageChange?: () => void;

    pagesRendered(pdfApp) {
        setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = "page-height"));

        if (pdfApp.page === pdfApp.pagesCount) {
            this.isFinishedViewingPdf = true;
        }

        const handlePageChange = (pageChangeEvent) => {
            this.isFinishedViewingPdf =
                this.isFinishedViewingPdf ||
                pageChangeEvent.pageNumber === pdfApp.pagesCount;
        };
        pdfApp.eventBus._on("pagechanging", handlePageChange);
        this.unBindPageChange = () =>
            pdfApp.eventBus._off("pagechanging", handlePageChange);
    }
    isAgree = false;

    closePopup() {
        this.$emit("close");
        this.approveOrders = [];
        URL.revokeObjectURL(this.pdf);
    }

    mounted() {
        this.fetchProformaDocument(this.approveOrders?.[0]?.id.toString());
    }
    unmounted(): void {
        this.unBindPageChange?.();
        this.pdfPage = 1;
    }
    /* API Connectivity --------------------------------------------------------------------------------------------- */
    fetchProformaDocument = async (id: number | string) => {
        if (!id) return;
        appAxios.value
            .get<Blob>(`/client/web/orders/${id}/proforma-document`, {
                headers: {
                    accept: "application/pdf",
                },
                responseType: "blob",
            })
            .then((response) => {
                const objectUrl = URL.createObjectURL(response.data);
                this.pdf = objectUrl;
            })
            .catch((res) => {
                console.log(`Fetch Proforma Document for Order #${id} error:`, res);
            });
    };

    approve() {
        this.fetchApprove(this.approveOrders?.[0]?.id.toString())
            .then((status) => {
                if (status === 200) {
                    this.approveOrders.shift();
                    this.closePopup();
                }
            })
            .catch((error) => {
                console.error("Error during fetchApprove:", error);
            });
    }

    fetchApprove = async (id?: number | string): Promise<number> => {
        if (!id) return 0;
        try {
            const response = await appAxios.value.post<APIResponse<void>>(
                `/client/web/orders/${id}/approve`,
            );
            return response.data.status.code;
        } catch (error) {
            console.log(`Fetch approve order #${id} error:`, error);
            return 0;
        }
    };
}
